import { Component, OnInit, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { MainLayout } from '../../layouts/main-layout';
import {
  ClockIcon,
  FilterIcon,
  LucideAngularModule,
  ShieldIcon,
  WrenchIcon,
} from 'lucide-angular';
import { BannerPrincipalCambioFiltros } from './cambio-filtros/banner-principal-cambio-filtros';
import { BeneficiosDelServicio } from './cambio-filtros/beneficios-del-servicio';
import { MarcasDeFiltros } from './cambio-filtros/marcas-filtros';
import { ServicioProfesional } from './cambio-filtros/servicio-profesional';
import { TiposDeFiltrosQueCambiamos } from './cambio-filtros/tipos-filtros-que-cambiamos';

@Component({
  selector: 'allas-instalacion-filtros',
  imports: [
    MainLayout,
    LucideAngularModule,
    BannerPrincipalCambioFiltros,
    TiposDeFiltrosQueCambiamos,
    MarcasDeFiltros,
    BeneficiosDelServicio,
    ServicioProfesional,
  ],
  template: `
    <allas-main-layout>
      <div class="bg-white w-full max-w-[1600px] mx-auto px-4 2xl:px-0">
        <!-- Titulo Filtros para Carro -->
        <h1 class="text-lg xl:text-4xl my-2 xl:my-4 font-medium fs-condensed">
          FILTROS PARA CARRO
        </h1>

        <!-- Banner Principal -->
        <allas-banner-principal-cambio-filtros />
        <allas-tipos-de-filtros-que-cambiamos />
        <allas-marcas-de-filtros />
        <allas-beneficios-del-servicio />
        <allas-servicio-profesional />
      </div>
    </allas-main-layout>
  `,
})
export class InstalacionFiltros implements OnInit {
  private title = inject(Title);
  private meta = inject(Meta);

  readonly filterIcon = FilterIcon;
  readonly clockIcon = ClockIcon;
  readonly wrenchIcon = WrenchIcon;
  readonly shieldIcon = ShieldIcon;

  ngOnInit() {
    this.setMetaTags();
  }

  private setMetaTags() {
    const pageTitle = 'Instalación de Filtros para Carro | Allas Repuestos';
    const description =
      'Servicio profesional de instalación de filtros para carro. Cambio de filtros de aceite, aire y combustible con envío a domicilio en Honduras.';
    const keywords =
      'filtros para carro, instalación filtros, cambio filtros, filtros aceite, filtros aire, filtros combustible, Allas Repuestos, envío a domicilio, Honduras, garantía, calidad';
    const imageUrl = 'https://www.allasrepuestos.com/logos/isotipo.webp';

    // --- Título de la página ---
    this.title.setTitle(pageTitle);

    // --- Meta Descripción ---
    this.meta.updateTag({
      name: 'description',
      content: description,
    });

    // --- Palabras Clave ---
    this.meta.updateTag({
      name: 'keywords',
      content: keywords,
    });

    // --- Open Graph Tags ---
    this.meta.updateTag({ property: 'og:title', content: pageTitle });
    this.meta.updateTag({ property: 'og:description', content: description });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:image', content: imageUrl });
    this.meta.updateTag({
      property: 'og:image:alt',
      content: 'Logo de Allas Repuestos',
    });

    // --- Twitter Tags ---
    this.meta.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image',
    });
    this.meta.updateTag({ name: 'twitter:title', content: pageTitle });
    this.meta.updateTag({ name: 'twitter:description', content: description });
    this.meta.updateTag({ name: 'twitter:image', content: imageUrl });

    // --- Icono del sitio (favicon / logo principal) ---
    this.meta.updateTag({
      name: 'icon',
      content: imageUrl,
    });
  }
}
